/**
 * AI SDK tool-result parts sometimes arrive as `{ type: "json", value: … }`.
 * History / Observe may also persist that wrapper as `toolOutput`.
 */
export function unwrapScoutToolPayload(value: unknown): unknown {
  if (!isRecord(value)) return value;
  const type = value.type;
  if ((type === "json" || type === "text") && "value" in value) {
    return value.value;
  }
  return value;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
